module.exports = __webpack_public_path__ + "static/BNPL-d0426393c5a4ecef450814dc1c185751.png";